import './Header.css';
import { Logo } from './elements/Logo/Logo';
import { Online } from '../svg/Online/Online';
import { HeaderNav } from './elements/HeaderNav/HeaderNav';
import { Balance } from './elements/Balance/Balance';
import { User } from './elements/User/User';
import { Benefit } from './elements/Benefit/Benefit';
import { useNavigate } from 'react-router-dom';

export const Header = ({}) => {
    const navigate = useNavigate();
    const linkMe = () => {
        navigate('/profile');
    };

    return (
        <header className={'header'}>
            <Logo />
            <Online />
            <HeaderNav />
            <Benefit />
            <Balance />
            <div onClick={linkMe} className="header__profile">
                <User />
            </div>
        </header>
    );
};
